import { useRef } from 'react';

import classNames from 'classnames';

import { useVwToPx } from '../../../../hooks/useVwToPx';

import classes from './MetaGameFeatureRewardComponent.module.scss';

type MetaGameFeatureRewardComponentProps = {
  amount: number;
  symbolUrl: string;
  fontSize?: number;
  className?: string;
};

const MetaGameFeatureRewardComponent = ({
  amount,
  symbolUrl,
  className,
  fontSize: propFontSize,
}: MetaGameFeatureRewardComponentProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const calculatedFontSize = useVwToPx({ ref, vwValue: 19 });
  const fontSize = propFontSize || calculatedFontSize;

  return (
    <div ref={ref} className={classNames(classes.giftMetaGameFeatureReward, className)} style={{ fontSize }}>
      <img className={classes.image} src={symbolUrl} />
      <span className={classes.amount} style={{ fontSize }}>
        {amount}
      </span>
    </div>
  );
};

export default MetaGameFeatureRewardComponent;
